function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.029 14.09a.75.75 0 00-.939-.496 7.878 7.878 0 01-9.682-9.69.75.75 0 00-.935-.934 9.376 9.376 0 1011.559 11.552.75.75 0 00-.003-.432z",
    fill: props.fill
  }));
}

export default SvgMoon;